import { useMetaTags } from '../../services/useMetaTags';
import {useTranslation} from 'react-i18next';
import './about.scss';
import logo from '../../assets/images/aboutPage/logo.svg';

const TOP_CARDS = [
    {
        iconClassName: 'about-icon-mission',
        title: 'Місія',
        text: 'Створити новий професійний медичний інформаційний і навчальний простір з залученням традиційних та інноваційних, хмарних, дистанційних технологій.',
    },
    {
        iconClassName: 'about-icon-goal',
        title: 'Мета',
        text: 'Забезпечити економію часу та зусиль понад 100 тисячам лікарів України в отриманні якісного, етичного, безперервного професійного розвитку. Залучити всі можливі ресурси: вітчизняні й міжнародні, освітні й інформаційно-довідкові, онлайн та офлайн.',
    },
    {
        iconClassName: 'about-icon-team',
        title: 'Команда',
        text: 'Команда accemedin.com - це креативні лікарі, менеджери, аналітики, дизайнери та програмісти. Ми працюємо для того, щоб кожен лікар України отримав всі можливості для розвитку і комунікації в професійній медичній спільноті.',
    },
];

const OFFERS_CARDS = [
    {
        iconClassName: 'about-icon-develop',
        title: 'Розвивайтеся',
        text: 'за допомогою провідних методик освіти дорослих людей',
    },
    {
        iconClassName: 'about-icon-work',
        title: 'Працюйте',
        text: 'з використанням у повсякденній практиці набутих знань',
    },
    {
        iconClassName: 'about-icon-earn',
        title: 'Заробляйте',
        text: 'легально, беручи участь у дослідженнях, опитуваннях і програмах',
    },
];

const START_STEPS = [
    'Зареєструвати власний кабінет на accemedin.com і найближчим часом отримати доступ до пакету «Преміум».',
    'Заповнити професійний профіль згідно інструкції (основні параметри: ПІБ, місце роботи, спеціальність).',
    'Відповідати на запитання, переглядати матеріали та виконувати щоденні завдання.',
];

const PARTNER_POINTS = [
    'Авторам, видавцям, організаціям (власникам цікавого наукового й освітнього контенту) - безоплатно використати ресурси платформи задля отримання додаткових контактів з лікарями різних спеціальностей.',
    'Компаніям, видавничим домам, медичним закладам - швидко доносити медичну, освітню та іншу інформацію до обраних категорій лікарів.',
];

function AboutCards({items}) {
    return (
        <div className="main-container">
            <div className="about-text-grid">
                {items.map((item) => (
                    <div className="about-text-card" key={item.title}>
                        <i className={`about-icon ${item.iconClassName}`} />
                        <h3>{item.title}</h3>
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function About() {
    const {t} = useTranslation();

    useMetaTags({
        title: `${t('footer.about')} | ${t('app.title')}`,
        description: t('app.description'),
        metas: [{name: 'keywords', content: t('app.keywords')}],
    });

    return (
        <div className="about-page">
            <section className="about-intro about-flex-center">
                <div className="about-title-block">
                    <img src={logo} alt="Accemedin" />
                    <h1>
                        Accelerator of Medical Information
                        <br />
                        (Акселератор Медичної Інформації) -
                        <span>це освітньо-інформаційна онлайн-платформа.</span>
                    </h1>
                </div>
            </section>

            <section className="about-text-block">
                <AboutCards items={TOP_CARDS} />
            </section>

            <section className="about-offers about-doctors about-flex-center">
                <div className="about-title-block">
                    <h4>Що ми пропонуємо лікарям</h4>
                    <p>
                        Кожен лікар, який вміє викладати, має власний контент, цікаві клінічні випадки, зображення та
                        готовий до співпраці, зможе стати автором відповідних розділів на accemedin.com і матиме
                        можливість отримувати авторські гонорари.
                    </p>
                </div>
            </section>

            <section className="about-text-block about-offers-text">
                <AboutCards items={OFFERS_CARDS} />
            </section>

            <section className="about-start-info">
                <div className="about-start-info-block">
                    <h4>Легкий старт уже сьогодні</h4>
                    <p>
                        для кожного українського лікаря, який має доступ до смартфона або комп&apos;ютера, починається з
                        кількох простих кроків:
                    </p>
                    <ol>
                        {START_STEPS.map((step) => (
                            <li key={step}>{step}</li>
                        ))}
                    </ol>
                </div>
            </section>

            <section className="about-offers about-partners about-flex-center">
                <div className="about-title-block">
                    <h4>Що ми пропонуємо партнерам</h4>
                    <ul>
                        {PARTNER_POINTS.map((point) => (
                            <li key={point}>{point}</li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className="about-join">
                <h2>
                    ПРИЄДНУЙТЕСЬ ДО ACCEMEDIN!
                    <br />
                    ГРОШІ Й ЗНАННЯ ЗА 15 ХВИЛИН!
                </h2>
            </section>
        </div>
    );
}
